import { render, staticRenderFns } from "./popUpGallery.vue?vue&type=template&id=1938ae8a&scoped=true"
import script from "./popUpGallery.vue?vue&type=script&lang=js"
export * from "./popUpGallery.vue?vue&type=script&lang=js"
import style0 from "./popUpGallery.vue?vue&type=style&index=0&id=1938ae8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938ae8a",
  null
  
)

export default component.exports